<template>
    <div class="footerBottom">
        <!--<div class="footer_top">
      <div class="footer_content">
        <div class="footer_content_top">
          <div style="width: 285px">
            <div class="content_text">{{language.card}}</div>
            <div style="width: 35px;background:#0088c7;height: 3px;margin: 10px 0"></div>
            <a href="http://www.forwardersmart.com/tools/cardDirectoryList.html" target="_blank">
              <div class="content_ref">
                <div class="content_icon">
                  <img src="../../assets/guest.png" alt />
                </div>
                <div class="content_ref_text" style="margin-left: 10px;">
                  <div>{{language.makeCard}}</div>
                  <div style="margin-top: 5px">{{language.extend}}</div>
                </div>
              </div>
            </a>
          </div>
          <div style="width: 285px">
            <div class="content_text">{{language.cloud}}</div>
            <div style="width: 35px;background:#0088c7;height: 3px;margin: 10px 0"></div>
            <a :href="linkCangnaer" target="_blank">
              <div class="content_ref">
                <img src="../../assets/clound_icon.png" style="width: 157px;height: auto" />
              </div>
            </a>
          </div>
          <div style="width: 285px">
            <div class="content_text">{{language.vip}}</div>
            <div style="width: 35px;background:#0088c7;height: 3px;margin: 10px 0"></div>
            <a :href="wanfaLink" target="_blank">
              <div class="content_ref">
                <div>
                  <img src="../../assets/wiffa-logo.png" style="width: 110px;height: auto" />
                </div>
                <div class="content_ref_text" style="margin-left: 10px">
                  <div>{{language.directories}}</div>
                  <div style="margin-top: 5px">{{language.know}}</div>
                </div>
              </div>
            </a>
          </div>
          <div style="width: 285px">
            <div class="content_text">{{language.business}}</div>
            <div style="width: 35px;background:#0088c7;height: 3px;margin: 10px 0"></div>
            <a href="service.html">
              <div class="content_ref">
                <div style="margin-top: 5px">
                  <img
                   :src="logoUrl"
                    alt
                    style="width: 248px;height: auto;border: 0px;"
                  />

                  <div class="content_ref_text" style="margin-top: 5px">{{language.platform}}</div>
                </div>
              </div>
            </a>
          </div>
        </div>
       
        <a :href="bannerLink"
           target="_blank">
          <img
            :src="bannerurl"
            style="width: 1200px;height: auto;position: absolute;bottom: 0;left: 50%;transform: translateX(-50%)"
          />
        </a>
      </div>
    </div>-->
        <div class="open-popup-box"
             v-show="popup==1">
            <div class="popup-main">
                <img src="https://yst-1251180497.cos.ap-nanjing.myqcloud.com/public/popup-close.svg"
                     class="close-popup"
                     @click.stop="dataChange('popup',0)">
                <div class="popup-info">
                    <p style="text-align:center;"
                       align="center">
                        <strong>直播文明公约</strong>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="margin-bottom: 15px; display: block;">
                        <span style="font-size:14px;">为规范本平台的基本秩序，创造良好的直播环境，促进平台健康发展，即日起将加大对平台内违法违纪用户、内容的打击处理力度，拒绝以“性暗示”、“挑逗”、“暴露”为代表的低俗化和无底线的直播内容，一经发现将立即严肃处理，绝不姑息。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">本公约适用于平台内所有主播及用户，适用于所有信息形式，包括但不限于主播及用户的昵称、签名、头像以及发布的图片、视频、直播封面、直播内容等。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">一、低质量内容或其它不合规行为：</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、直播时不与玩家互动，玩手机、电脑等；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、直播时没有支架，画面摇晃或只有半边脸；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3、直播时灯光昏暗不清晰；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4、直播时超过3分钟画面无人或挂机；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">5、直播时躺在床上或沙发上直播；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">6、直播时邋遢、穿睡衣等不注意个人形象；</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">（本月内出现以上行为第一次切断视频警告；第二次关闭直播权限一天；第三次永久关闭直播权限）</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">二、色情低俗内容：</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、严禁展示男女性器官，或仅用肢体掩盖或用很小的遮盖物掩盖人体等隐秘部位及衣着过分暴露等；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、严禁较长时间或较多给人以感官刺激的床上镜头、接吻、爱抚、淋浴，及类似的与性行为有关的间接表现或暗示；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3、严禁有明显的性挑逗、性骚扰、性侮辱或类似效果的言语、画面、肢体动作、音乐及音效等；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4、严禁展示和宣扬不健康的婚恋观和婚恋状态，如婚外恋、一夜情等；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">5、严禁使用粗俗语言（性暗示语言）等；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">6、严禁以成人电影、情色电影、三级片、偷拍、走光、露点及各种挑逗性文字图片或表演作为标题、分类或宣传推广，如引导宣传QQ群/微信号或其它媒介等。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">（出现以上行为直接封号，且与签约方薪资不再结算。情节严重移交司法机关）</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">三、涉及政治、违法的内容：</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、严禁违反宪法确定的基本原则，煽动抗拒或者破坏宪法、法律、行政法规实施；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、严禁危害国家统一、主权和领土完整，泄露国家秘密，危害国家安全，损害国家尊严、荣誉和利益，宣扬恐怖主义、极端主义；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3、严禁诋毁民族优秀文化传统，煽动民族仇恨、民族歧视，侵害民族风俗习惯，歪曲民族历史和民族历史人物，伤害民族感情，破坏民族团结；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4、严禁危害社会公德，扰乱社会秩序，破坏社会稳定，宣扬淫秽、赌博、吸毒，渲染暴力、恐怖，教唆犯罪或者传授犯罪方法；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">5、严禁侵害未成年人合法权益或者损害未成年人身心健康；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">6、任何机构和个人不得在本平台使用”电视台“、”广播电台“、”电台“、”TV“等广播电视专有名称开展直播；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">7、严禁侮辱、诽谤他人或者散布他人隐私，侵害他人合法权益；</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">8、 法律、行政法规禁止的其他内容。</span>
                    </p>
                    <p style="margin-bottom: 15px; display: block;">
                        <span style="font-size:14px;">（出现以上行为直接封号，且与薪资不再结算。情节严重移交司法机关）</span>
                    </p>
                    <p>
                        <strong><span style="font-size:14px;">四、不合规身份：</span></strong>
                    </p>
                    <p>
                        <span style="font-size:14px;">1、严禁未成年人在本平台注册直播；</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">2、严禁利用他人身份证信息申请帐号进行直播或非本人直播。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">本平台的用户可以拨打“举报”电话对违规的主播及用户进行举报，平台将会对举报信息进行核实处理，同时平台也将对恶意举报、投诉的用户进行相应的处罚。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">本平台绝不收取任何形式的押金、咨询费、服务费或以任何名义收取费用，如遇此类情况均属欺诈。</span>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="text-align:right;"
                       align="right">
                        <span style="font-size:13px;">大连万发联合航贸科技有限公司</span>
                    </p>

                </div>
            </div>
        </div>

        <div class="open-popup-box"
             v-show="popup==2">
            <div class="popup-main">
                <img src="https://yst-1251180497.cos.ap-nanjing.myqcloud.com/public/popup-close.svg"
                     class="close-popup"
                     @click.stop="dataChange('popup',0)">
                <div class="popup-info">
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:center;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="center">
                        <strong style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 21px;font-family: 宋体;">文明直播承诺书</span></strong><strong
                                style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important"></strong>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">直播服务本关行业发展</span>&nbsp;<span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">用户权益和社会进步</span>.&nbsp;<span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">维护立播服务秩序，发挥直播积极社会作用，推动直播行业健康发展，是广大从业者的共同责任</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">.&nbsp;</span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">在此，我们向社会做出庄严承诺：</span></span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">一，遵守国家法律法规，坚持依法办网，努力做遵纪守法的</span>&nbsp;<span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">“</span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">中国好网站</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">”</span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">。</span></span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">二、坚持用先进技术传播向上向善的网络文化，大力弘扬社会主义核心价值现，弘扬中华优秀传统文化，积极传递社会正能量</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">三、不传播、不运营包含法律法规禁止和违反公序良俗的信息内容，不传播、不运营带有损害用户利益、社会公共利益和国家利益的信息内容</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">四、尊重用户自主选择信息内容和服务方式的权利，不强制或诱导用户观看各类直播信息</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">五，推行真实身份信息注册制度，对直播信息服务发布者</span>.<span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">、直播信息服务使用者进行真实身份信息验证</span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">.</span></span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">六、如若从事新闻信息服务活动必须按照《互联网新闻信息服务管理规定》履行相关手续，取得从业资格，并在许可范围内开展互联网新闻信息服务</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">七、坚持</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">“</span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">谁运营谁负责</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">”</span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">、</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">“</span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">谁发布谁负责</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">’&nbsp;</span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">的原则，落实主体责任，健全管理机制，完善审核流程，确保直播信息服务内容健康、可信、可追溯，不给任何有害信息传播空间</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">.</span></span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">八、做好直播信息发布、传播和处理的相关情况记录保存，在有关部门依法查询时及时提供</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">九、做好直播信息发布者信用等级管理体系，提供与信用等级挂钩的服务，建立黑名单制度，情节严重的永久封禁，并向主管机关报告</span>.&nbsp;<span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">对涉嫌违反治安管理或者刑事犯罪的，及时向公安机关报告</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">.</span></span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">十、完善用户协议，引导广大用户合法、文明使用直播平台，自觉抵制发布、传播暴力、凶杀</span>.<span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">、色情、低俗等有害不良信息的行为，努力为未成年人健康成长营造绿色网络空间</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">.</span></span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">十一、遵循合法、正当、必要的原则开展用户个人信息的收集，使用和保存活动</span>.&nbsp;<span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">收集、使用和保存用户个人信息时，应明确告知用户使用目的及范围。未经用户本人同意，不擅自收集、使用和保存用户个人信息</span><span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: Calibri;">.</span></span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">十二、</span>&nbsp;<span
                                  style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">落实信息安全保密责任，加强对用户身份信息、注册信息、网络行为信息的保护管理，不出售、篡改、泄露或违法公开用户个人数据</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">十三，建立社会举报投诉渠道，公布举报投诉联系方式，主动接受社会监督，及时处理违法违规不良信息</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">十四、坚持公平竞争，提倡互助共进，坚决抵制侵权盗版活动，坚决反对不正当竞争行为，共同维护公平竞争、和谐共赢的良好环境</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">十五、坚持把社会效益放在首位，通过为广大网民、社会提供更好、更便捷的服务，履行企业社会责任，实现行业杜会价值</span>.</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:justify;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="justify">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 15px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">十六、主动接受主管部分的指导和监督管理，共同维护互联网行业诚信形象。</span>&nbsp;&nbsp;
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                    </p>
                    <p style="margin: 0px 0px 24px;padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;clear: both;min-height: 1em;color: rgba(0, 0, 0, 0.9);font-size: 17px;letter-spacing: 0.578px;text-align:right;font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, &#39;Helvetica Neue&#39;, &#39;PingFang SC&#39;, &#39;Hiragino Sans GB&#39;, &#39;Microsoft YaHei UI&#39;, &#39;Microsoft YaHei&#39;, Arial, sans-serif;"
                       align="right">
                        <span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 12px;font-family: Calibri;"><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">大连万发联合航贸科技有限公司</span>&nbsp;&nbsp;
                            &nbsp;<span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-family: 宋体;">特此</span></span><span style=";padding: 0px;max-width: 100%;box-sizing: border-box !important;overflow-wrap: break-word !important;font-size: 12px;font-family: 宋体;">承诺</span>
                    </p>

                </div>
            </div>
        </div>

        <div class="open-popup-box"
             v-show="popup==3">
            <div class="popup-main">
                <img src="https://yst-1251180497.cos.ap-nanjing.myqcloud.com/public/popup-close.svg"
                     class="close-popup"
                     @click.stop="dataChange('popup',0)">
                <div class="popup-info">
                    <p style="text-align: center;"
                       align="center">
                        <strong>隐私保护政策</strong>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">本隐私保护政策介绍了您所享有的个人信息权利，细化消息通知等功能收集使用说明信息的情况，便于您的理解。请您在使用/继续使用WIFFA货代人演艺平台（下称“平台”）的产品与/或服务前仔细阅读和充分理解全文，并在同意全部内容后使用/继续使用。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">WIFFA货代人演艺平台（下称“平台”）非常重视用户的隐私和个人信息保护，也感谢您对我们的信任。本隐私政策阐述了我们将如何处理您的个人信息，并申明了公司对保护用户隐私的承诺。因此我们希望您能够仔细阅读、充分理解本政策的内容，并在需要时，按照本政策的说明，作出您认为适当的选择。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">本隐私政策政策适用于由大连万发联合航贸科技有限公司开发和运营的直播平台：www.wiffa-exh.com网站，网站服务单独设置了隐私政策或个人信息保护规则的，单独的隐私政策或规则优先适用，单独的隐私政策或规则未提及的内容，使用本政策。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">在使用我们的网站服务前，请您务必仔细阅读并充分理解本隐私政策，特别是以粗体/粗体下划线标识的条款，您应重点阅读，并在确认充分理解并同意后使用相关产品或服务。您使用或继续使用我们的提供的各项产品或服务，表示您已充分理解并同意我们本隐私政策的全部内容。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">如您在阅读本隐私政策过程中有任何疑惑的，我们为您提供了多种反馈渠道，具体请见本政策“如何联系我们”章节，我们会尽快为您作出解答。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">一、我们如何收集和使用您的个人信息</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">二、我们如何使用Cookie及同类技术</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">三、我们如何共享、转让、公开披露您的个人信息</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">四、您如何管理个人信息</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">五、我们如何存储您的个人信息</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">六、我们如何保护您的个人信息</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">七、未成年人保护</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">八、本政策的更新</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">九、争议解决</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">十、如何联系我们</span>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">一、我们如何收集和使用您的个人信息</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">在您使用我们的服务过程中，我们会按照如下方式收集您在使用我们服务时主动提供的或因为使用服务而产生的信息，用以向您提供、优化我们的服务以及保证您的账户安全。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">请注意，如果您仅需用平台直播的基本功能服务（即进行实时视频、音频、图文等形式的信息浏览），您无需授权并向我们提供任何个人信息。但我们会出于保障产品和服务安全的目的收集您使用我们的产品或服务过程中所产生的网络日志和行为日志信息。单独的设备信息、日志信息是无法识别特定自然人身份的信息，在您未提供其他能够识别您个人身份的个人信息的情况下，此类信息无法与特定自然人进行关联。如果我们将这类非个人信息与您提供的其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">您需授权我们收集和使用您的个人信息的其他功能/场景包括：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（一）注册、登录</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）当您注册、登录平台直播账号时，我们会收集您的手机号码、密码，并为平台注册用户生成平台号，收集这些信息是为了帮助您完成平台账号注册，保护您账号的安全。手机号码属于敏感信息，收集该信息是为了以此作为更为高效、可靠的登录凭证。通过注册验证且您阅读并同意本政策及用户协议后，将完成账号注册及登录。如果您仅需使用浏览、搜索服务，您不需要注册账号及提供上述信息。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）在您登录平台直播账号后，您可以自愿选择是否完善头像、昵称、年龄、性别、生日、地区、签名等个人资料。如果您不提供前述信息，不会影响您享受平台直播的基本功能。如果您仅需要使用浏览功能，您也可以选择在不登录且不提供上述信息的情况下进行。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（二）实名认证</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">在您使用身份认证的功能或相关服务所需时，根据国家相关法律法规，您可能需要提供您的真实身份信息以完成实名认证，如果您不提供相关信息，可能无法使用具体功能或服务。主要包括以下几类：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）注册平台账号时，需要提供您的手机号码完成实名认证，完成认证后您方可发送弹幕或上传内容。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）当您申请注册为网络直播服务发布者（主播）时，平台直播将根据相关法律规定收集您的真实姓名、身份证件信息进行实名身份认证，并通过您的面部识别信息进行身份一致性核验。如您选择人工认证方式完成实名认证，我们可能收集您的真实姓名、身份证件信息（包括但不限于身份证、相应证件的正反面图片和您手持相应身份证件的照片）。通过实名认证后，您方可在平台上从事直播发布活动。如果您有主播佣金提现需求，您还需要提供与您身份信息一致的银行卡信息。为了准确验证您的身份，我们将对上述信息进行比对核验。您的真实姓名、身份证件信息、面部识别信息、手持身份证件信息和银行卡号属于个人敏感信息，我们收集该类信息是基于实名认证要求，您可以拒绝提供，如果拒绝提供您将可能无法获得相关服务（直播开播、提现等功能），但不影响您正常使用产品的浏览和观看功能。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（3）当您参与某些活动时，根据相关监管政策要求，我们需要对提现用户进行实名认证，可能需要获取您的身份证号、姓名等信息，具体以活动页面公示内容为准。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（三）安全保障</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">为保障网络安全、预防网络犯罪、识别您的账号异常以及反欺诈目的，我们会收集您以下信息：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）网络访问日志信息和用户日志信息。这些日志信息包括：账号、登录日志、操作时间、操作记录、网络源地址和目标地址、网络源端口、客户端硬件特征、通讯群组名称、昵称、简介、备注、标识、用户信息发布、转发、评论记录、服务故障信息；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）您的设备信息。包括：设备型号、操作系统、唯一设备标识符、浏览器类型、使用的语言、访问日期和时间、登陆IP地址、接入网络的方式、类型和状态、网络质量数据、WIFI扫描列表、WIFI名称（SSID）、WIFI MAC地址（BSSID）。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">上述信息将被用于综合识别、检测违规行为和内容、实名核验，并采取必要的记录、审计、分析和处置措施。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（四）提供个性化推荐、展示或推送服务</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">当您使用平台直播时，我们会收集您的如下信息：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）关注、搜索、浏览偏好（例如：感兴趣的直播）等您的操作、使用行为信息、性别、年龄；&nbsp;</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）您的设备信息；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（3）反馈、发布、点赞、评论、打赏等您主动提供的互动信息。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">除取得您授权或法律法规另有规定外，我们不会将上述信息与您在应用程序中提供的任何个人身份信息相结合，以确保不识别到您个人。我们可能将上述信息与来自我们服务所收集的其他非身份信息结合，通过程序算法进行特征与偏好分析、基于特征标签进行间接人群画像，用以向您个性化推荐、展示或推送您可能感兴趣的或更合适您的特定功能或服务：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）向您展示、推荐或推送与您有更高相关程度的直播、音视频。为有助于您自主管理个性化内容，当您对平台推送的个性化内容不感兴趣或希望减少某些个性化内容推荐时，可在“推荐”栏目每个静态画面的右下角找到标签按钮，点击该按钮，通过精准屏蔽主播、精准屏蔽分类、“不感兴趣”三种方式管理您的个性化推送内容。您也可以通过清除Cookie的方式减少我们依赖Cookie及同类技术向您推送的个性化内容。具体请见“（二）我们如何使用Cookie”部分。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）向您推荐与您相关程度更高的个性化广告。个性化广告是为了减少无关广告对您的侵扰，向您推荐的与您更相关的广告内容。您可以点击这里了解并管理个性化广告的内容，也可以通过“平台直播APP”-“设置”-“隐私设置”-“广告个性化管理”进行查阅和管理。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（五）调研与推广营销</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">当您选择参加我们及我们的关联方或第三方举办的有关调查问卷、抽奖中奖、线上或线下推广营销等运营活动时，可能需要您在相关表单中填写姓名、通信地址、联系方式等个人信息。如拒绝提供相关信息，可能会影响您参加相关活动，但不会影响您使用其他功能。只有经过您的同意，我们及第三方才会收集和处理相关信息，以保障为您提供相应的产品服务。此外，基于平台运营管理需求，我们可能会使用部分平台主播联系方式与其沟通业务运营事宜。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（六）消息通知</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">你知悉并同意，我们在运营中可能会通过你在使用产品及/或服务的过程中所提供的联系方式（手机号码），向你同时发送一种或多种类型的通知，例如消息告知、身份验证、安全验证、用户调研；此外，我们也可能会以短信的方式，为你提供你可能感兴趣的服务、功能或活动等商业性信息。但请你放心，如你不愿接受这些信息，你可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（七）客服和申诉</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">当您向我们的客服或通过产品交互页面发起有关账号安全和未成年人消费相关的申诉或进行咨询时，为了方便与您联系、帮助您解决问题，确保您的账号安全，我们可能需要您提供部分信息或资料，您可以自行决定是否向我们提供，这些资料可能包括您的账号实名信息和账号使用信息，收集这些信息是为了确保您的账号不在被盗或未被授权的情况下发起申诉或咨询，保障您的账号和财产安全。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（九）来自第三方的信息</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如您在平台直播间或平台合作游戏中授权将平台账号与相关游戏账号绑定，我们可能会获取您游戏账号、昵称、头像、openID日志信息，上述信息将被用于向您推荐您更感兴趣的直播内容。具体个人信息处理情况以直播间公告内容为准。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（十）授权同意的例外</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用、共享、转让、公开披露您的相关个人信息无需征求您的授权同意：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、与国家安全、国防安全等国家利益直接相关的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、与公共安全、公共卫生、公众知情等重大公共利益直接相关的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4、出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">5、所收集的个人信息是您自行向社会公众公开的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">7、根据您要求签订和履行合同、提供服务、实现售后和交易服务所必需的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">8、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">9、有权机关的要求、法律法规规定的其他情形。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">请理解，由于平台服务的更新迭代，如果某一功能或服务未及时在本隐私政策中声明收集了你的信息，我们仍然会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的授权同意。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</span>
                    </p>
                    <p style="margin-top: 15px; margin-bottom: 5px; display: block;">
                        <strong><span style="font-size:14px;">二、我们如何使用Cookie和同类技术</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">Cookie 和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用平台及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie 或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie
                            用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie 和同类技术主要为了实现以下功能或服务：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1. 保障产品与服务的安全、高效运转</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">我们可能会设置认证与保障安全性的Cookie 或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2. 帮助您获得更轻松的访问体验</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（例如：记录搜索、表单填写）。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3. 为您推荐、展示、推送您可能感兴趣的内容或广告</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）我们可能会利用此类技术了解您的偏好和使用习惯，进行数据分析，以改善产品服务、推荐用户感兴趣的信息或功能，并优化您对广告的选择。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）在平台的分享页中，我们可能会使用Cookie对浏览活动进行记录，用于向您推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4. Cookie的清除</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">三、我们如何共享、转让、公开披露您的个人信息</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（一）共享</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">我们将对您的信息承担保密义务，除以下情形外，我们不会对外共享或提供您的个人信息：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、事先已获得您的明确授权或同意；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、根据适用的法律法规、法律程序、行政司法机关的要求或司法争议解决而需共享您的个人信息；</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">3、在法律要求或允许的范围内，为了保护平台直播及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">4、与授权合作伙伴共享：为了向您提供更完善、优质的产品和服务，我们可能委托授权合作伙伴或使用第三方SDK相关技术为您提供服务或代表我们履行职能。我们仅会出于本隐私政策声明的合法、正当、必要、特定、明确的目的共享您的信息，合作伙伴只能接触到其履行职责所需的信息，且不得将信息用于其他任何目的。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">目前，我们的授权合作伙伴包括以下类型：</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">（1）基础服务提供商：包括提供实名认证、支付、一键登录、消息推送、地理位置定位、反欺诈的合作方。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">（2）委托我们进行信息推广和广告投放的合作伙伴：您授权我们有权与委托我们进行信息推广和广告投放的合作伙伴共享我们使用您的相关信息形成的无法识别您的个人身份的间接用户画像、设备信息、去标识化或匿名化处理后的分析/统计类信息，以帮助其在不识别您个人身份的前提下进行广告或决策建议、提高广告有效触达率、衡量广告和相关服务的有效性。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">（3）提供数据服务（包括网络广告监测、数据统计、数据分析）的合作伙伴：为维护/改进我们的产品/服务、为您提供更好的内容，我们可能会与提供该服务的指定合作伙伴共享您的相关信息（包括：设备信息、广告展示和点击记录、终端型号、地理位置），除非得到您的同意，我们不会与其共享您的个人身份信息。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">（4）内容安全监测服务提供商：我们可能与特定内容安全监测服务提供商合作进行违规音视频标注和分析，可能会与这些服务提供商共享直播流信息。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">（5）提供开播或直播推流服务的合作伙伴：当我们与提供开播或直播推流服务的第三方平台进行合作时，我们可能共享用户昵称、弹幕、评论、排行榜、打赏信息等直播间已公开的用户数据。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">对共享信息的合作方，我们会与其订立专门的数据保护协议或数据安全条款，约定严格的数据保护措施，在确保安全的前提下共享信息，令其按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">（二）转让</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">1、 您自行提出要求的；</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">2、 事先已征得您的明确授权同意：</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">3、 在平台公司发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">（三）公开披露</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">我们仅会在以下情况下，公开披露您的个人信息：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、除了因需要对违规账号、欺诈行为等违反平台协议及平台规则进行处罚公告、公布中奖/获胜者等名单时脱敏展示相关信息等必要事宜而进行的必要披露外，我们不会对您的个人信息进行公开披露。您同意我们在上述必要场景披露您的相关信息，同时我们将审慎评估公开披露的合法性、正当性、合理性，采取严格的个人信息安全保护措施对其进行保护。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、如具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的授权同意后再公开披露，但法律法规另有规定的或本政策另有约定的除外。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">四、您如何管理个人信息</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">平台非常重视用户的个人信息权益，并尽全力保障您对自己个人信息享有的各项权利，以便您拥有充分的能力保障您的信息安全。您的权利包括：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（一）查询、更正和删除个人信息</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如您在行使上述权利的过程中遇到困难，或其他目前可能无法向您提供自行查询/更正/删除服务的，您可以按照本隐私政策所提供的方式联系我们。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">当您发现我们违反法律、行政法规的规定或者双方的约定存储处理您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正或补充。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（二）撤回授权</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">您可以通过改变手机、平板电脑等智能移动设备的设置撤回授权同意。管理是否根据您的信息展示广告或根据您的信息生成广告标识符。您也可以通过注销账号的方式，永久撤回我们继续处理您个人信息的全部授权。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如您在行使上述权利的过程中遇到困难，或其他目前可能无法向您提供自行撤回授权的，您可以按照本隐私政策所提供的方式联系我们。请您知悉，当您撤回授权后，我们无法继续为您提供撤回授权所对应的特定功能和/或服务。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（三）个人信息副本获取与转移</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如您需要获取您的个人信息副本，您可以与我们联系并说明您的要求，我们将在收到您联系后的15个工作日内完成核验用户身份和处理。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如您需要转移我们处理的个人信息，我们将根据相关法律法规的要求，协助您进行转移。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（四）注销账号</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">您可以通过联系客服注销自己的账号：在您主动注销账户之后，我们将在十五个工作日内进行处理。账号注销后，我们将停止为您提供与该平台账号相关联的所有产品和服务，根据适用法律的要求删除您的个人信息或进行匿名化处理，但法律法规另有规定的除外。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">请注意，账号注销后您已发布的所有内容（包括提供的音视频、图文等信息）将转为匿名发布，如需删除内容，请在申请注销前自行处理。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（五）访问和要求解释隐私政策</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">我们将在您首次注册平台直播时，向您提示本隐私政策并由您自主作出选择同意的决定。另外，您可以通过平台直播网页末端或在【平台平台规则】-【隐私政策】页面，随时查看本隐私政策的全部内容。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如您对我们的个人信息处理规则有任何疑问，您可以通过本隐私政策披露的联系方式要求我们解释说明。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（六）有权提前获得停止运营的告知</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如果平台直播平台终止服务或运营，我们将及时停止收集您个人信息的活动，并至少提前三十日将停止运营的通知以公告或逐一送达等形式通知您，并在终止服务或运营后对所持有的您的个人信息进行删除或匿名化处理，法律法规另有规定的除外。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（七）其他权利</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如平台用户（仅限自然人）不幸逝世，其近亲属为了自身的合法、正当利益，可以对去世用户的相关个人信息行使查阅、复制、更正、删除等权利，但去世用户生前另有安排的除外。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">关于上述权利，您可以填写《平台直播个人信息保护反馈表》 ，发送邮件我们联系并说明您的要求，我们将在收到您联系后的15个工作日内进行身份核验和处理。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">五、我们如何存储您的个人信息</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，不会对您的个人信息跨境传输。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">我们仅在为提供服务目的所必须的期间内保留您的个人信息，在您未撤回、删除或未注销账号前，我们会保留相关信息。超出必要期限后，我们将对个人信息进行删除或匿名化处理，但在下列情形下，我们需要遵守相关法律法规要求留存您的个人信息。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、《中华人民共和国网络安全法》第二十一条第三款要求监测、记录网络运行状态、网络安全事件的技术措施的网络日志留存不得少于六个月；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、《互联网直播服务管理规定》要求记录互联网直播服务使用者发布内容和日志信息，保存六十日；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3、《电子商务法》规定商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4、为遵守法院判决、裁定或其他法律程序的规定；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">5、为执行平台协议或本政策、维护社会公共利益，保护公司及公司关联公司、其他用户或雇员的人身安全或其他合法权益所合理必须的用途。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">六、我们如何保护您的个人信息</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。我们会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄漏、毁损或丢失。目前，平台已经具备相应的数据安全和信息保护能力。</span>
                    </p>
                    <p style="margin-bottom: 5px; display: block;">
                        <span style="font-size:14px;">您的账户均有安全保护功能，请妥善保管您的账户及密码信息。我们将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即按照本政策文末所列明的公开联系方式联络我们客服，以便我们采取相应措施。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <strong><span style="font-size:14px;">七、未成年人保护</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如您为未成年人，我们要求您请您的父母或监护人在仔细阅读本隐私政策，并在征得您的父母或监护人的同意之后，在他们的指导下使用我们的服务。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。如果您认为我们可能不当地持有关于未成年人的信息，请联系我们。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">如果您是未满14周岁的儿童的监护人，当您在完成或帮助儿童完成产品或服务的注册、使用前，应当仔细阅读本政策，具体产品的隐私政策（如有）和《平台儿童个人信息保护指引》 以决定是否同意本政策、具体产品的隐私政策，以便儿童能使用我们提供的产品或服务。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">为保护儿童及未成年人的个人信息，我们设立了专门的儿童个人信息保护专职机构，如您对您所监护的儿童的个人信息保护有相关疑问或权利请求时，请通过《平台儿童个人信息保护指引》 中披露的联系方式与我们联系。我们会在合理的时间内处理并回复您。</span>
                    </p>
                    <p style="margin-top: 15px; margin-bottom: 5px; display: block;">
                        <strong><span style="font-size:14px;">八、本政策的更新</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、为给您提供更好的服务以及随着平台业务的发展，本隐私政策也会随之更新，该等更新构成本隐私政策一部分。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们将在更新后的本隐私政策生效前，通过显著位置提示或向您发送推送消息或以其他方式通知您，也请您访问平台直播以便及时了解最新的隐私政策。如该等更新造成您在本隐私政策下权利的实质减少或重大变更，我们会再次征求您的明示同意。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">您需理解，只有在您确认并同意变更后的隐私政策，我们才会依据变更后的隐私政策收集、使用、处理和存储您的个人信息；您有权拒绝同意变更后的隐私政策，但请您知悉，一旦您拒绝同意变更后的隐私政策，可能导致您不能或不能继续完整使用平台直播的相关服务和功能，或者无法达到我们拟达到的服务效果。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、本隐私政策所指的重大变更包括但不限于：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（3）个人信息共享、转让或公开披露的主要对象发生变化；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">（6）个人信息安全影响评估报告表明存在高风险时。</span>
                    </p>
                    <p style="margin-top:15px;display:block;">
                        <strong><span style="font-size:14px;">九、争议解决</span></strong>
                    </p>
                    <p>
                        <span style="font-size:14px;">本隐私政策适用中华人民共和国大陆地区法律。任何因本隐私政策以及我们处理您个人信息事宜引发的争议，首先可友好协商解决；协商不成的，您同意通过向本协议签署地（广东省广州市番禺区）有管辖权的法院提起诉讼来寻求解决方案。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">本隐私政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。</span>
                    </p>
                    <p style="margin-top: 15px; margin-bottom: 10px; display: block;">
                        <strong><span style="font-size:14px;">十、如何联系我们</span></strong>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">若您对我们的隐私政策有任何疑问、意见或建议，可随时联系我们。</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">公司名称：大连万发联合航贸科技有限公司</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">注册地址：大连市中山区世纪街26号1单元16层1号</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">联系人：WIFFA货代人演艺平台法务合规部</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">联系电话：0411-82817405</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;"><br /></span>
                    </p>
                    <p>
                        <span style="font-size:14px;">我们将尽快审核所涉问题，并在验证您的用户身份后十五日内回复。</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="open-popup-box"
             v-show="popup==4">
            <div class="popup-main">
                <img src="https://yst-1251180497.cos.ap-nanjing.myqcloud.com/public/popup-close.svg"
                     class="close-popup"
                     @click.stop="dataChange('popup',0)">
                <div class="popup-info">
                    <p style="text-align: center;"
                       align="center">
                        <strong><span style="font-size: 17px;">用户服务协议</span></strong>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">用户服务协议是您（下称“用户”）与网站服务提供者（“WIFFA货代人演艺平台”下称“平台”）之间签订的协议。平台是指由大连万发联合航贸科技有限公司开发和运营的直播网站。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">1、重要须知</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1.1 用户欲注册和使用直播平台，必须事先认真阅读、充分理解本协议中各条款，尤其应特别注意免除或者限制平台责任的免责条款及对用户的权利限制条款。如用户不同意本协议，用户应不注册使用或主动取消虎牙提供的服务。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1.2 特别提醒：如用户是未成年人或其他不完全民事行为能力人，请务必在监护人的陪同下阅读本协议，注册使用平台，在未经监护人明示同意的前提下，请勿使用平台相关服务，也请监护人切实履行监护责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1.3 在用户接受本协议之后，此文本可能因国家政策、产品以及履行本协议的环境发生变化而进行修改，修改后的协议发布在该平台上。若用户对修改后的协议有异议的，请立即停止访问、使用，若用户继续访问或使用，视为对修改后的协议予以认可。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1.4 网站平台目前向用户提供直播服务，如果某一特定服务有单独的协议、规则、指引，用户须遵守该单独的协议、规则和指引，用户接受其他的所有服务均应遵守本协议。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">1.5 平台会在本协议的基础上，制定发布平台规则，平台规则是本协议的有效组成部分，用户对本协议的接受与遵守也视为对平台规则的接受与遵守。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;"><br /></span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">2、平台账号的注册、使用与个人信息保护</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.1 用户需通过实名手机号注册账号，注册成功之后，平台会按系统规则自动分配给用户一个号码，该号码即为直播平台账号。用户需自行设置符合安全要求的密码。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.2 本直播平台账号的性质是用户使用平台服务的凭证，平台账号的所有权属于平台，用户仅有账号的使用权。 用户不得有偿或无偿转让平台账号，以免产生纠纷。用户应当自行承担由此产生的任何责任，同时平台保留追究上述行为人法律责任的权利。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.3 平台账号还是用户持有、使用相关虚拟财产、道具的身份凭证。用户若需要接受平台提供的增值服务，平台账号同时也是用户支付费用、接受增值服务的凭证。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.4 为向用户提供一致性的产品和服务体验，使用户能够便捷完成平台产品的注册和登录，平台会对用户的账号数据提供同等安全保护。包括用户服务协议、隐私政策及其他协议、平台规则等条款的约束。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.5 用户可以按照平台的业务规则用平台账号登录和使用平台提供的服务。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.6 平台账号使用权仅属于申请注册并完成实名认证的用户，禁止账号的赠与、借用、租用、转让或售卖。具体的实名认证方式，可能包括基于移动电话号码、基于身份证明文件等一种或多种方式的结合，具体将按照您使用的特定服务内容、国家法律法规的特定要求有所差异。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.7
                            用户保证注册平台账号时填写的身份信息是真实的，任何非法、不真实、不准确的用户信息所产生的责任由用户承担。用户应不断更新注册资料，符合及时、详尽、真实、准确的要求。所有原始键入的资料将引用用户的账号注册资料。如果因用户的注册信息不真实而引起的问题，以及对问题发生所带来的后果，平台不负任何责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.8
                            用户平台账号的昵称须遵守《互联网用户账号信息管理规定》及国家法律法规、监管要求、平台规则关于昵称合法性的要求，不得设置任何包含危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容作为昵称；否则平台可回收您的账号昵称，并重置为默认状态，情节严重的，平台可能会冻结修改昵称权限甚至封禁账号。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">用户理解：平台将随着国家监管的要求和变化，而不时调整对账号昵称合法性的判断标准；账号昵称的回收、重置不影响用户以邮箱、手机号码、第三方认证方式登录本直播平台并使用平台提供的平台服务。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.9
                            为了充分利用平台账号资源，如果用户存在长期未登陆使用平台账号的情形，平台有权对账号进行注销、回收、替换或采取删除该账户在本直播平台数据库中的任何记录（包括但不限于注册信息等）等清理措施，相应服务同时终止。平台在对此类账户进行清理前，将以包括但不限于弹窗、网站公告、站内消息、客户端推送信息等方式通知用户。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.10 用户的平台账号、密码属于保密信息，平台应当采取积极的措施保护用户账号、密码的安全。用户的注册信息作为平台的商业秘密进来保护。但用户同时明白，互联网的开放性以及技术更新非常快，非平台可合理控制的因素导致用户泄漏的，平台不承担责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.11 用户应当妥善保管自己的平台账号、密码，用户就其账号及密码项下之一切活动负全部责任，包括用户数据的修改，以及其他所有的损失由用户自行承担。用户须重视平台账号密码保护。用户如发现他人未经许可使用其账号时立即通知平台。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.12
                            用户平台账号在丢失或遗忘密码后，可遵照平台的申诉途径及时申诉请求找回账号。用户应不断提供能增加账号安全性的个人密码保护资料。用户可以凭账号身份认证信息、初始注册资料及个人密码保护资料填写申诉单向平台申请找回账号。平台的密码找回机制仅负责识别申诉单上所填资料与系统记录资料的正确性，而无法识别申诉人是否系真正账号使用人。对用户因被他人冒名申诉而致的任何损失，平台不承担任何责任，用户知晓平台账号及密码保管责任在于用户，平台并不承诺平台账号丢失或遗忘密码后用户一定能通过申诉找回账号。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.13
                            如果平台账号的使用者存在使用归属争议，平台将按照评判规则，根据用户提交的信息进行判定。平台账号存在争议的情况下，平台有权暂时中止争议账号的使用，由此带来的损失由用户自行承担，上述损失包括但不限于：用户与第三方发生的纠纷，通信中断，用户资料、邮件和游戏道具及相关数据等的清空，相关服务中止等。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.14 请用户注意勿在使用本直播平台服务中透露自己的相关账户信息及对应密码等重要资料，否则由此带来的任何损失由用户自行承担。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.15 用户在使用本直播平台服务时不可将自认为隐私的信息发表、上传至本直播平台，也不可将该等信息通过本直播平台的服务传播给其他人。若用户的行为引起的隐私泄漏，由用户承担责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2.16 就下列相关事宜的发生，本直播平台不承担任何法律责任：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）平台根据法律规定或相关政府机关、安全机关、司法机关的要求提供用户的个人信息；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）由于用户将用户密码告知他人或与他人共享注册账户，由此导致的任何财产损失、个人信息的泄漏，或其他非因平台原因导致的上述损失或泄漏；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（3）任何由于黑客攻击、电脑病毒侵入造成的任何财产损失、虚拟财产损失、信息泄漏；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;"
                              draggable="true">（4）因不可抗力导致的任何财产损失、虚拟财产损失、信息泄漏。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">2.17平台重视对用户个人信息的保护，关于用户的个人信息依《隐私政策》受到保护与规范，详情请参阅《隐私政策》 。</span>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">3、用户行为规则</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3.1 用户保证使用本直播平台发布、传播的信息的真实性、准确性，同时保证不会利用平台的服务制作、复制、发布、传播、存储含有下列内容的信息：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）反对宪法所确定的基本原则的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（3）损害国家荣誉和利益的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（4）煽动民族仇恨、民族歧视，破坏民族团结的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（8）侮辱或者诽谤他人，侵害他人知识产权或其他合法权益的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（10）含有虚假、有害、胁迫、侵害他人隐私、中伤、低俗、或其它道德上令人反感的内容的；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（11）含有法律、行政法规禁止的其他内容的。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3.2 用户在使用本直播平台服务时应遵守国家广告等相关法律法规,不得在本直播平台上违规进行广告发布、商品销售等商业行为，包括但不限于以下行为：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）发布宣传色情网站、成人用品网站等色情、低俗内容；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）发布宣传假冒伪劣产品或未经授权销售的产品内容；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（3）发布宣传国家明令禁止或未取得国家许可销售的产品内容；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（4）发布宣传游戏代挂、代练、虚假人气、贩卖虚拟货币、平台道具等内容；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（5）发布宣传游戏外挂、辅助等内容；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（6）发布组织、宣传网络兼职内容；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（7）宣传其他平台、网络游戏链接；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（8）恶意刷屏、扰乱平台秩序；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（9）其他违反法律法规或平台平台规则的内容。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3.3
                            用户不得进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本“软件”系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本“软件”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3.4
                            用户不得进行任何破坏平台服务公平性或者其他影响本直播平台正常秩序的行为，包括但不限于主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）、恶意多开账号等违反公平和诚实信用原则的行为来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众。不正当参与平台活动的用户，系统将自动甄别并剔除，平台有权根据自身平台的大数据分析能力、技术能力进行判断，并判断相关行为是否违规，并对利用不正当手段获利的结果不予认可。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3.5 未经平台书面许可，用户不得自行或授权、允许、协助任何第三人对本直播平台及其系统进行地址扫描、网络端口扫描、操作系统探测等扫描及/或探测，不得对本直播平台上的任何内容进行非法获取从而用于（包括但不限于）：违法销售个人信息、宣传、增加点击量、浏览量、提供付费服务等。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">“非法获取”是指采用非正常浏览的手段、方式非法获取、擅自使用本直播平台内任何内容的行为，具体行为包括但不限于：利用机器人、“蜘蛛”(spider)程序、爬虫程序、拟人程序等非自然用户行为或利用BUG（又叫“漏洞”或者“缺陷”）避开、破坏技术措施，对本直播平台内的任何内容进行监视、读取、复制、转存、展示、传播、镜像、上载、下载。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3.6 用户不得有其他损害平台利益的行为。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">3.7
                            若用户违反本协议的相关规定，平台有权根据情节轻重，采取包括但不限于以下处罚措施：暂时限制账号的使用、永久冻结账号某项功能、永久封停账号、回收账号、剔除违法所得、扣罚保证金或佣金、公示处罚、终止所有服务等；因用户违反本协议，导致或产生第三方主张的任何索赔或损失，用户应当独立承担责任，给平台造成损失的，平台有权要求用户赔偿。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">3.8 平台按照本协议及相关平台规则或相关法律法规，限制、冻结或终止用户对平台服务的使用，而由此给用户带来的损失由用户自行承担。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">4、告知声明</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4.1
                            用户须明白，在使用平台服务的过程中可能存在来自他人包括威胁性的、诽谤性的、令人反感的或非法的内容或行为，或侵犯他人权利（包括知识产权）的匿名或冒名的信息风险，用户须承担以上风险，平台对服务不作担保，不论是明确的或隐含的，包括所有有关信息真实性、适商性、适于某一特定用途、所有权和非侵权性的默示担保和条件，对因此导致任何因用户不正当或非法使用服务产生的直接、间接、偶然、特殊及后续的损害，不承担任何责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4.2 用户使用平台服务必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本条款，对于用户违法或违反本协议的使用(包括但不限于言论发表、传送等)而引起的一切责任，由用户负全部责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4.3
                            平台的服务同大多数因特网产品一样，易受到各种安全问题的困扰，包括但不限于：1）透露详细个人资料，被不法分子利用，造成现实生活中的骚扰；2）哄骗、破译密码；3）下载安装的其它软件中含有“特洛伊木马”等病毒，威胁到个人计算机上信息和数据的安全，继而影响对本软件的使用。对于发生上述情况的，用户应当自行承担责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4.4 用户理解，互联网技术的不稳定性，可能导致政府政策管制、病毒入侵、黑客攻击、服务器系统崩溃或者其他现今技术无法解决的风险发生，上述风险可能导致平台服务中断或账号道具损失，对此等非人为因素引起的损失平台不承担责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">4.5 平台不对发布在本网站上的广告的产品效果、宣传、信息准确性负责，用户在接触这些广告时自行判断。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">4.6 用户同意运营商向其接收信息的装置或软件包括但不限于固定电话、移动电话、电子邮箱、站内信、QQ、微博、微信等发送服务信息和商业性广告。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">5、知识产权</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">5.1 平台的视频、音频等元素，平台服务标志、标识以及专利权，平台对此享有上述所有内容的知识产权。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">5.2 用户使用本直播平台服务只能在本协议以及相应的授权许可协议授权的范围使用平台知识产权，未经授权超范围使用的构成对平台的侵权。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">5.3
                            用户在使用本直播平台服务时发布上传的文字、图片、音视频、软件以及表演等用户原创的信息，此部分信息的相关权利归属用户，但用户的发表、上传行为是对平台服务平台的授权，用户确认将其发表、上传的信息非独占性、永久性地授权给平台，该授权可转授权。平台可将前述信息在平台旗下的服务平台上使用，可再次编辑后使用，也可以由平台授权给合作方使用。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">5.4 若本直播平台内的信息以及其他用户上传、存储、传播的信息有侵犯用户或第三人的知识产权的，平台提供专属投诉通道。具体详见投诉电话 。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">6、通知</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">6.1 用户同意平台以以下合理的方式向用户送达各类通知：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）公示的文案；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（2）系统消息、弹出消息、客户端推送的消息；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（3）根据用户预留于本直播平台的联系方式发出的电子邮件、手机短信、函件等。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">6.2
                            对于在本直播平台上因交易活动引起的任何纠纷，用户同意司法机关可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向用户送达法律文书。用户指定接收法律文书的手机号码、电子邮箱等联系方式为用户在本直播平台注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。用户指定的邮寄地址为用户的法定联系地址或用户提供的有效联系地址。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">6.3 用户同意司法机关可采取以上一种或多种送达方式向用户达法律文书，司法机关采取多种方式向用户送达法律文书，送达时间以上述送达方式中最先送达的为准。</span>
                    </p>
                    <p style="margin-bottom:15px;display:block;">
                        <span style="font-size:14px;">6.4 用户应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由用户自行承担由此可能产生的法律后果。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">7、其他条款</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">7.1 本协议条款的签订、解释以及争议的解决均适用中华人民共和国法律。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">7.2 本协议的签署地点为大连市中山区，若用户与平台发生争议的，双方同意将争议提交协议签署地有管辖权的人民法院诉讼解决。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">7.3 本协议由本平台公布在网站上，对平台具有法律约束力；用户一经点击接受或者直接登录、查看、发布、使用的行为视为对本协议的接受，对用户具有法律约束力。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;"><br /></span>
                    </p>
                    <p style="text-align: right;"
                       align="right">
                        <span style="font-size: 12px;">大连万发联合航贸科技有限公司</span>
                    </p>

                </div>
            </div>
        </div>

        <div class="open-popup-box"
             v-show="popup==6">
            <div class="popup-main">
                <img src="https://yst-1251180497.cos.ap-nanjing.myqcloud.com/public/popup-close.svg"
                     class="close-popup"
                     @click.stop="dataChange('popup',0)">
                <div class="popup-info">
                    <p style="text-align: center;font-size: 20px;"
                       align="center">
                        <strong>未成年人家长监护工程</strong>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">随着网络在青少年中的普及，未成年人接触网络直播已经成为普遍现象。为保护未成年人健康参与直播，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络直播提供以下意见：</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">一、主动控制直播时间。直播只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络直播中的行为和体验。</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">二、不参与可能耗费较多时间的直播设置。不玩大型角色扮演类直播，不玩有PK类设置的直播。在校学生每周玩直播不超过2小时。</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">三、不要将直播当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠直播来缓解压力。</span>
                    </p>
                    <p style="margin-bottom:10px;display:block;">
                        <span style="font-size:14px;">四、养成积极健康的直播心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">五、注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。</span>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="text-align: center;"
                       align="center">
                        <span style="font-size:16px;"><strong>网络直播未成年人家长监护工程</strong></span>
                    </p>
                    <p>
                        <br />
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">一、申请条件：</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、 申请人需为被监护未成年人的法定监护人；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、 申请人的被监护人年龄小于18周岁；</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">3、 申请人需为大陆公民，不含港、澳、台人士。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;"><br /></span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">二、申请需要提交材料：</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、监护人信息表明书（包含监护人身份证明复印件）；</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">2、被监护人信息表明书（包含被监护人所玩直播相关信息及身份证明复印件）；</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">3、填写网络直播未成年人家长监护申请书、保证书、授权书并手工签字（需下载，填写并打印，签字）。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;"><br /></span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">三、申请方式</span></strong>
                    </p>
                    <p>
                        <span style="font-size:14px;">监护人可以通过邮件发送申请信息表至服务邮箱：wiffa@wiffa.net，进行申请。<a href="https://email-1251180497.cos.ap-nanjing.myqcloud.com/%E5%AE%B6%E9%95%BF%E7%9B%91%E6%8E%A7%E7%94%B3%E8%AF%B7%E4%B9%A6.doc">点击下载申请表</a></span>
                    </p>
                    <p>
                        <span style="font-size:14px;"><br /></span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">四、监督方式</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">A、冻结帐号</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">根据监护人意愿冻结相关直播帐号，限制登录</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">B、帐号动态监控：</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">登录、修改密码等操作将发短信至监护人手机。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">（1）帐号已绑定认证手机，将监护人手机替换为认证手机。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">（2）帐号未绑定认证手机，将监护人手机绑定成认证手机。</span>
                    </p>
                    <p>
                        <span style="font-size:14px;"><br /></span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <strong><span style="font-size:14px;">五、其他要求</span></strong>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:14px;">1、申请人应提交较完备的申请材料，对未提供的信息要及时补充；可请熟知电脑、互联网、直播的人员进行协助，以便提供详实资料；</span>
                    </p>
                    <p>
                        <span style="font-size:14px;">2、申请人应保证提交的信息真实有效；对于提供虚假信息或伪造证件，我司将保留进一步追究法律责任的权利。</span>
                    </p>

                </div>
            </div>
        </div>
        <div class="open-popup-box"
             v-show="popup==5">
            <div class="popup-main">
                <img src="https://yst-1251180497.cos.ap-nanjing.myqcloud.com/public/popup-close.svg"
                     class="close-popup"
                     @click.stop="dataChange('popup',0)">
                <div class="popup-info">
                    <p style="text-align:center;font-size: 20px;"
                       align="center">
                        <strong>直播纠纷处理</strong>
                    </p>
                    <p>
                        <br />
                    </p>

                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:16px;">1. 我们不能对用户发表的视频或言论的正确性进行保证。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:16px;">2. 用户在直播发表的内容仅表明其个人的立场和观点，并不代表我们的立场或观点。 作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。 我们不承担任何法律及连带责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:16px;">3. 因用户违反本协议所导致的直播中断或终止向用户提供本服务，我们无需为此承担任何责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:16px;">4. 我们不对直播或本服务的功能、软件、服务及其所包含内容的延误、不准确、错误、遗漏或由此产生的任何损害， 以任何形式向用户或任何第三方承担任何责任。</span>
                    </p>
                    <p style="margin-bottom:5px;display:block;">
                        <span style="font-size:16px;">5. 对于因不可抗力或我们不能控制的原因造成的网络服务中断或其它缺陷，我们不承担任何责任， 但将尽力减少因此而给用户造成的损失和影响。 此外，就因我们定期或不定期的检修或者维护而引发的合理时间的中断，我们也无需为此承担任何责任。</span>
                    </p>

                    <p>
                        <br />
                    </p>
                    <p style="text-align:right;"
                       align="right">
                        <span style="font-size:16px;">大连万发联合航贸科技有限公司</span>
                    </p>

                </div>
            </div>
        </div>
        <div class="footer_bottom">
            <div class="footer_bottom_content">
                <div class="footer_bottom_content-left">
                    <div class="bottom_text cur"
                         @click.stop="dataChange('popup',5)">直播纠纷处理</div>
                    <div class="bottom_text cur"
                         @click.stop="dataChange('popup',4)">用户协议</div>
                    <div class="bottom_text cur"
                         @click.stop="dataChange('popup',3)">隐私保护</div>
                    <div class="bottom_text cur"
                         @click.stop="dataChange('popup',2)">直播承诺</div>
                    <div class="bottom_text cur"
                         @click.stop="dataChange('popup',1)">直播公约</div>
                    <div class="bottom_text cur"
                         @click.stop="windowOpen('https://www.12377.cn/')">中国互联网不良信息举报中心</div>
                    <div class="bottom_text cur"
                         @click.stop="windowOpen('https://jbts.mct.gov.cn/')">全国文化和旅游市场网上举报投诉处理系统</div>
                    <div class="bottom_text cur"
                    @click.stop="dataChange('popup',6)">未成年人家长监护工程</div>
                    <div class="bottom_text">未成年人关怀热线：0411-82817405</div>
                    <div class="bottom_text">违法和不良信息举报：0411-82817405</div>
                    <div class="bottom_text">{{language.customerPhone}}:86-411-82817405</div>
                    <div class="bottom_text">公司地址：辽宁省大连市中山区人民路35号时代广场B座1601</div>
                    <div class="bottom_text">{{language.internetRecord}}：辽B-2-4-20080120-21</div>
                    <div class="bottom_text">© {{language.allRightsReserved}} 2023 WIFFA SHIPPINGTECH CO.,LTD. All Rights Reserved</div>
                </div>

                <div class="IMGcontent beian">
                    <a class="beian3"
                       target="_blank"
                       href="http://ln.cyberpolice.cn/alertPawsAction.do?method=LOUT&amp;&amp;id=dl">安安</a>
                    <a class="beian2"
                       target="_blank"
                       href="javascript:void(0)"
                       style="cursor:text">网警</a>
                    <a class="beian1"
                       target="_blank"
                       href="https://exhxcx.shippingchina.com/Public/uploads/2020-06-13/ICP2019-2024.jpg">工商</a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Cook from '../../common/cookie'
export default {
	props: {
		language: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			logoUrl: require('@/assets/logo.png'),
			bannerurl: require('../../assets/banner.jpg'),
			linkCangnaer: 'http://www.forwardersmart.com/',
			wanfaLink: 'http://www.wiffa.net/',
			bannerLink: 'http://www.wiffa.net/meeting2020/pre/index.html',
			popup: 0
		}
	},
	mounted() {
		let lan = Cook.get('lang')
		if (lan == 'ch') {
		} else {
			this.logoUrl = require('@/assets/logo_en.png')
			this.bannerurl = require('../../assets/banner_en.jpeg')
			this.linkCangnaer =
				'http://www.forwardersmart.com/enindex/aboutus.html'
			this.wanfaLink = 'http://www.wiffa.net/en/index/index.html'
			this.bannerLink = 'http://www.wiffa.net/meeting2020/pren/index.html'
		}
	},
	methods: {
		dataChange: function(field, val, specialType = '') {
			this[field] = val
			if (field == 'popup') {
				if (val) {
					document.getElementsByTagName('body')[0].style.height =
						window.innerHeight + 'px'
					document.getElementsByTagName('body')[0].style.overflow =
						'hidden'
				} else {
					document.getElementsByTagName('body')[0].style.height =
						'auto'
					document.getElementsByTagName('body')[0].style.overflow =
						'visible'
				}
			}
		},
		windowOpen: function(url) {
			window.open(url)
		},

		setHomepage(obj, vrl) {
			try {
				obj.style.behavior = 'url(#default#homepage)'
				obj.setHomePage(vrl)
			} catch (e) {
				if (window.netscape) {
					try {
						netscape.security.PrivilegeManager.enablePrivilege(
							'UniversalXPConnect'
						)
					} catch (e) {
						alert(
							"此操作被浏览器拒绝！\n请在浏览器地址栏输入“about:config”并回车\n然后将 [signed.applets.codebase_principal_support]的值设置为'true',双击即可。"
						)
					}
					var prefs = Components.classes[
						'@mozilla.org/preferences-service;1'
					].getService(Components.interfaces.nsIPrefBranch)
					prefs.setCharPref('browser.startup.homepage', vrl)
				} else {
					alert(
						'您的浏览器不支持，请按照下面步骤操作：1.打开浏览器设置。2.点击设置网页。3.输入：' +
							vrl +
							'点击确定。'
					)
				}
			}
		}
	}
}
</script>

<style scoped>
.footerBottom img {
	border: 0px;
}
.footerBottom {
	min-width: 1200px;
	width: 100%;
}
.footer_top {
	height: 300px;
	padding-top: 50px;
	background: #125caf;
	position: relative;
}
.footer_content {
	width: 1200px;
	margin: auto;
}
.footer_bottom {
	height: 113px;
	background: #0f4083;
	display: flex;
	align-items: center;
	justify-content: center;
}
.footer_bottom_content {
	width: 1600px;
	margin: auto;
	display: flex;
}
.footer_bottom_content-left {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: start;
	margin-right: 20px;
	flex-grow: 1;
}
.content_text {
	color: #ffffff;
	font-size: 18px;
	text-align: left;
}
.footer_content_top {
	display: flex;
	display: -webkit-box;
	margin-left: 30px;
}
.footerBottom .footer_content_bottom {
	background: #ffffff;
	width: 1200px;
	height: 160px;
	margin-top: 45px;
	position: relative;
}
.footer_content_centre {
	position: absolute;
	top: 22px;
	left: 250px;
}
.footer_code {
	position: absolute;
	top: 18px;
	right: 116px;
}
.image_text {
	position: absolute;
	color: #268fa7;
	font-size: 26px;
	z-index: 1000;
	top: 22px;
	left: 30px;
}
.footer_btn {
	display: flex;
	display: -webkit-flex;
	align-items: center;
}
.content_ref {
	display: flex;
	display: -webkit-box;
	align-items: center;
}
.content_icon {
	width: 45px;
	height: 45px;
	font-size: 20px;
	line-height: 45px;
	text-align: center;
	color: #ffffff;
}
.content_ref_text {
	color: #ffffff;
	font-size: 14px;
	text-align: left;
}
.bottom_text {
	color: #91dfff;
	font-size: 12px;
	margin: 0 9px;
}

.bottom_text a {
	color: #91dfff;
	font-size: 14px;
}
.footerBottom .IMGcontent {
	text-align: center;
	margin-bottom: 18px;
	width: 300px;
	height: 45px;
	padding: 5px 0;
}
.footerBottom .Text3 a {
	color: #fcfcfc;
}
a {
	text-decoration: none;
}
.content_text a {
	color: #ffffff;
}
a.beian1,
a.beian2,
a.beian3 {
	float: right;
	overflow: hidden;
	display: block;
	width: 55px;
	height: 55px;
	text-align: left;
	background: url(../../assets/HYmiddleItem14.png) no-repeat 0 0;
	text-indent: -1000px;
}
a.beian3 {
	background-position: -90px 0;
}
a.beian2 {
	background-position: -45px 0;
	width: 45px;
}
.exh_btn_left {
	width: 180px;
	height: 47px;
	line-height: 47px;
	font-size: 18px;
	color: #85d3ff;
	text-align: center;
	/* border: 1px solid #107ce6;
  border-radius: 5px; */
	border-right: 1px solid #107ce6;
	cursor: pointer;
}
.open-popup-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
}
.popup-main {
	width: 45%;
	height: 90%;
	background: #ffffff;
	border-radius: 10px;
	box-sizing: border-box;
	padding: 40px 20px 30px 20px;
	overflow: hidden;
	font-size: 16px;
	color: #333333;
	position: relative;
}
.popup-main .close-popup {
	width: 35px;
	height: 35px;
	position: absolute;
	right: 10px;
	top: 5px;
	cursor: pointer;
}
.popup-info {
	width: 100%;
	overflow: auto;
	height: 100%;
	font-size: 16px;
	padding-bottom: 50px;
	box-sizing: border-box;
}
.bottom_text.cur {
	cursor: pointer;
}
.bottom_text.cur:hover {
	color: #315efb;
}
</style>